export interface AssetTag {
  _id: string
  description: string
  color?: string
  organization?: string
  isAutoGenerated?: boolean
}

export type AssetTagWithCount = AssetTag & { count?: number }

export const useAssetTagStore = defineStore(`asset-tag`, () => {
  const getAssetTags = async (pagination = false, organizationQuery?: string | Record<string, unknown>) =>
    useCrudMethods<AssetTag>("/asset-tags").readItems({ query: JSON.stringify({ organization: organizationQuery }), pagination })
  const getAssetTagById = async (id: AssetTag["_id"]) => useCrudMethods<AssetTag>("/asset-tags").readItemById(id)
  const updateAssetTag = async (id: AssetTag["_id"], item: Partial<AssetTag>) =>
    useCrudMethods<AssetTag>("/asset-tags").updateItem(id, item)
  const createAssetTag = async (item: Partial<AssetTag>) => useCrudMethods<AssetTag>("/asset-tags").createItem(item)
  const deleteAssetTag = async (id: AssetTag["_id"]) => useCrudMethods<AssetTag>("/asset-tags").deleteItem(id)

  const getTagAssetCount = async (organization?: string): Promise<Array<CountAggregate>> => {
    const { data } = await useSamApi<Array<CountAggregate>>(`/asset-tags/asset-count${organization ? `?organization=${organization}` : ""}`)
    return data
  }

  return {
    getAssetTags,
    getAssetTagById,
    updateAssetTag,
    createAssetTag,
    deleteAssetTag,

    getTagAssetCount,
  }
})
